var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 17",
    fill: "#9a9a9a",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9923 4.9016L11.326 8.14C10.5806 8.57472 9.65927 8.57472 8.91391 8.14L3.24671 4.9016C2.82519 4.66312 2.67471 4.12808 2.91231 3.7048C3.15343 3.28328 3.69111 3.13544 4.11263 3.37656C4.11439 3.37744 4.11703 3.37832 4.11879 3.3792L9.78599 6.6176C9.99367 6.732 10.2454 6.732 10.4539 6.6176L16.122 3.3792C16.5418 3.13544 17.0812 3.27888 17.3241 3.69952C17.325 3.70128 17.3258 3.70304 17.3276 3.7048C17.5643 4.12808 17.4147 4.66312 16.9923 4.9016ZM18.4795 0H1.75951C0.787992 0 -0.000488281 0.78848 -0.000488281 1.76V14.344C-0.000488281 15.3155 0.787992 16.104 1.75951 16.104H18.4795C19.4519 16.104 20.2395 15.3155 20.2395 14.344V1.76C20.2395 0.78848 19.4519 0 18.4795 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.911fab1ac2eca5660b2c58b7416b9fd8.svg";
export { ForwardRef as ReactComponent };